import React from 'react';
import { Loading } from '@shape-ds/components';
import { useTranslation } from 'react-i18next';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import './style.scss';

interface TableDataContainerProps {
  isLoading: boolean;
  children: React.ReactNode;
  dataLength?: number;
  className?: string;
  type?: string;
}

const TableDataContainer: React.FC<TableDataContainerProps> = ({
  children,
  dataLength = 0,
  isLoading,
  className,
  type,
}) => {
  const { t } = useTranslation();
  return (
    <div className={`external-tables-wrapper ${className}`}>
      {isLoading && (
        <div className="loading">
          <Loading data-testid="table-loading" />
        </div>
      )}
      {!isLoading && children}
      {!isLoading && dataLength === 0 && (
        <div className="loading external-tables-no-data">
          <CancelOutlinedIcon />
          {t(`monitoring:tables:messages.no_data.${type}`, {
            defaultValue: t('monitoring:tables:messages.no_data.Empty'),
          })}
        </div>
      )}
    </div>
  );
};

export default TableDataContainer;
